export default "__VITE_ASSET__DAB8QiWN__"